import { UserDTO } from 'BaseDataTypes';
export interface AgreementSimpleDTO {
  id: number;
}
export interface AgreementSummaryDTO extends AgreementDTO {
  clientName: string;
  plantName?: string | null;
}

export interface AgreementDetailDTO extends AgreementDTO {
  clientId: number;
  plantId?: number | null;
}

interface AgreementDTO extends AgreementSimpleDTO {
  creationDate: Date;
  lastInvoiceDate?: Date | null;
  lastInvoiceValue?: number | null;
  nextInvoiceDate?: Date | null;
  nextInvoiceValue?: number | null;
}

export interface ClientSimpleDTO {
  id: number;
  name: string;
}

export interface ClientSummaryDTO extends ClientSimpleDTO { }

export interface ClientDetailDTO extends ClientSimpleDTO {
  plants: PlantSimpleDTO[];
  agreements: AgreementSimpleDTO[];
  jobs: JobDTO[];
  components: ComponentDTO[];
  features: FeatureSimpleDTO[];
}

export interface ComponentSimpleDTO {
  id: number;
  typeNumber: string;
}
export interface ComponentDTO extends ComponentSimpleDTO {
  description?: string | null;
  fwVersion?: string | null;
  swVersion?: string | null;
  vendor?: string | null;
  group: ComponentGroupDTO;
}
export interface ComponentSummaryDTO extends ComponentDTO {
  clientName: string;
  plantName?: string | null;
}

export interface ComponentDetailDTO extends ComponentDTO {
  clientId: number;
  plantId?: number | null;
  jobs: JobDTO[];
}

export enum ComponentGroupDTO {
  PLC = 'PLC',
  HMI = 'HMI',
  Sensor = 'Sensor',
  Actuator = 'Actuator',
  Other = 'Other',
}
export const ComponentGroupTranslation: {
  [key in ComponentGroupDTO]: string;
} = {
  [ComponentGroupDTO.PLC]: 'PLC',
  [ComponentGroupDTO.HMI]: 'HMI',
  [ComponentGroupDTO.Sensor]: 'Sensor',
  [ComponentGroupDTO.Actuator]: 'Aktuator',
  [ComponentGroupDTO.Other]: 'andet',
};

export interface FeatureSimpleDTO {
  id: number;
  amount: number;
}

export interface FeatureSummaryDTO extends FeatureSimpleDTO {
  featureOptionName: string;
  plantName?: string | null;
  clientName: string;
}

export interface FeatureDetailDTO extends FeatureSimpleDTO {
  featureOptionId: number;
  plantId?: number | null;
  clientId: number;
}

export interface FeatureOptionSimpleDTO {
  id: number;
  name: string;
}
export interface FeatureOptionDTO extends FeatureOptionSimpleDTO {
  alternateName?: string | null;
  description?: string | null;
}

export interface FeatureOptionSummaryDTO extends FeatureOptionDTO {}

export interface FeatureOptionDetailDTO extends FeatureOptionDTO { }

export interface JobSimpleDTO {
  id: number;
}
export interface JobDTO extends JobSimpleDTO {
  interval: JobIntervalDTO;
  intervalValue: number;
  description?: string | null;
  status: JobStatusDTO;
  created: Date;
  completed?: Date | null;
}

export interface JobSummaryDTO extends JobDTO {
  clientName: string;
  plantName?: string | null;
  componentName?: string | null;
  createdByName: string;
  responsibleName: string;
}

export interface JobDetailDTO extends JobDTO {
  clientId: number;
  plantId?: number | null;
  componentId?: number | null;
  createdById: number;
  responsibleId: number;
}

export enum JobIntervalDTO { // this is much easier to work with when we send the enum as string from the backend
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly',
  Custom = 'Custom',
}

export const JobIntervalTranslation: {
  [key in JobIntervalDTO]: string;
} = {
  [JobIntervalDTO.Custom]: 'Brugerdefineret',
  [JobIntervalDTO.Daily]: 'Daglig',
  [JobIntervalDTO.Monthly]: 'Månedlig',
  [JobIntervalDTO.Quarterly]: 'Kvartalvis',
  [JobIntervalDTO.Weekly]: 'Ugelig',
  [JobIntervalDTO.Yearly]: 'Årlig',
};

export enum JobStatusDTO {
  Open = 'Open',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}
export const JobStatusTranslation: {
  [key in JobStatusDTO]: string;
} = {
  [JobStatusDTO.Open]: 'Åben',
  [JobStatusDTO.InProgress]: 'I gang',
  [JobStatusDTO.Completed]: 'Udført',
  [JobStatusDTO.Cancelled]: 'Annulleret',
};
export interface PlantSimpleDTO {
  id: number;
  plantName: string;
}
export interface PlantDTO extends PlantSimpleDTO {
  hwpPlantName?: string;
}

export interface PlantSummaryDTO extends PlantDTO {
  clientName: string;
  projectManagerName?: string | null;
  processEngineerName?: string | null;
  plcEngineerName?: string | null;
}

export interface PlantDetailDTO extends PlantDTO {
  clientId: number;
  projectManagerId?: number | null;
  processEngineerId?: number | null;
  plcEngineerId?: number | null;
  components: ComponentSimpleDTO[];
  features: FeatureSimpleDTO[];
  jobs: JobDTO[];
  agreements: AgreementSimpleDTO[];
}
